import { Chip, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { AddContactPrimaryIcon, BackMobileIcon, BlockIcon, CancelIcon, CancelWhiteIcon, EditContactIcon, FalkonAiWhiteIcon, GroupBrodCastCardIcon, SettingsVertiIcon, TrashIcon } from '../../icon';
import { CampaignModel, Contact, ConversationCardModel, ConversationModel, Group, GroupChatModel } from '../../models/conversations';
import * as selector from '../../selectors/selectors';
import { UserService } from '../../services/UserService';
import { UtilityService } from '../../services/UtilityService';
import Avatar from '../shared/avatar.component';
import { ActionLabels, appNote, buttonLabels, ToasterTexts, ViewTextLabels } from '../shared/constants';
import { MenuItemRender } from '../shared/menu-item-render';
import GroupchatIcon from "../../icons/group-chat-avator-icon.svg";
import { useEffect, useMemo, useState } from 'react';
import { FalkonAiService } from '../../services/FalkonAiService';
import ButtonComponent from '../shared/button/button.component';
import { UpdateChatSummaryHistory } from '../../actions';
import { SettingsModel } from '../../models/settings-model';
import ContactViewComponent from '../contacts/contact-view.component';
import Confirm_Dialog from '../shared/confirm-dialog.component';
import { ContactService } from '../../services/ContactService';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { pushContacts } from '../../reducers/reducer';

interface Props {
    CardTitle: string;
    CloseContactInfo: () => void;
    Contact?: Contact;
    GroupChatInfo?: GroupChatModel;
    campaignInfo?: CampaignModel;
    ActiveCardIndex?: number;
    handleEditGroupName?: () => void;
    CardData: ConversationCardModel;
}
const ContactInfoComponentNew = (props: Props) => {
    const dispatch = useDispatch()

    const Contacts: Contact[] = useSelector(selector.contacts);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const History: { [key: string]: ConversationModel[] } = useSelector(selector.history)
    const ChatSummaryHistory: { [key: string]: { Sentiment: string, Summary: string } } = useSelector(selector.chatSummaryHistory)
    const Settings: SettingsModel = useSelector(selector.settingsObj)

    const [loader, setLoader] = useState<boolean>(false)
    const [sentiment, setSentiment] = useState<string>("")
    const [summary, setSummary] = useState<string>("")
    const [ButtonName, setbuttonName] = useState<string>("Generate chat summary")
    const [panelOpen, setPanelOpen] = useState(false);
    const [isExiting, setIsExiting] = useState(false);
    const [contact, setContact] = useState<Contact>(props.Contact);
    const [openEditContact, setOpenEditContact] = useState<boolean>(false)
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false)
    const [text, setText] = useState<string>("")
    const [dailogButtonName, setDailogButtonName] = useState<string>("")
    const [dialogAction, setDialogAction] = useState<string>("")
    const [isloading, setIsLoading] = useState<boolean>(false);

    const contactActionData = useMemo(() => [
        {
            Name: !!props.CardData?.Contact?.ID ? ActionLabels.EDIT_CONTACT : ActionLabels.ADD_CONTACT,
            Icon: !!props.CardData?.Contact?.ID ? EditContactIcon : AddContactPrimaryIcon,
            Hide: props.CardData?.Contact?.IsUnsubscribed,
            OnClick: () => handleEditContact(),
        },
        {
            Name: props.CardData?.IsBlocked ? ActionLabels.UNBLOCK_CONTACT : ActionLabels.BLOCK_CONTACT,
            Icon: BlockIcon,
            OnClick: () => openBlockConfirmDialog(props.CardData?.IsBlocked),
        },
        {
            Name: ActionLabels.DELETE_CONTACT,
            Icon: TrashIcon,
            OnClick: () => openConfirmDialog(),
            Hide: !!props.CardData?.Contact?.ID ? false : true,
        },
    ], [props.CardData?.Contact?.ID, props.CardData?.IsBlocked, props.CardData?.IsUnsubscribed]);

    useEffect(() => {
        const contact = Contacts?.find(x => x.PhoneNumber === props.CardData?.PhoneNumber) ?? {
            PhoneNumber: props.CardData?.PhoneNumber,
            MaskedPhoneNumber: props.CardData?.MaskedPhoneNumber,
        } as Contact
        setContact(contact);
    }, [props.Contact]);

    useEffect(() => {
        if (!isExiting) return;
        const timer = setTimeout(() => props.CloseContactInfo(), 100);
        return () => clearTimeout(timer);
    }, [isExiting]);

    const handleEditContact = () => {
        setOpenEditContact(true)
    }

    const closeEditContact = () => {
        setOpenEditContact(false)
    }

    const openBlockConfirmDialog = (isBlocked: boolean) => {
        setShowConfirmDialog(true)
        setText(isBlocked ? appNote.UNBLOCK_CONTACT : appNote.BLOCK_CONTACT)
        setDailogButtonName(isBlocked ? buttonLabels.UNBLOCK : buttonLabels.BLOCK)
        setDialogAction("Blocked")
        setIsLoading(false)
    }

    const openConfirmDialog = () => {
        setShowConfirmDialog(true)
        setText(appNote.CONTACT_DELETE)
        setDailogButtonName(buttonLabels.DELETE)
        setDialogAction("Delete")
        setIsLoading(false)
    }

    const closeConfirmDialog = (isConfim: any) => {
        if (!!isConfim && (dialogAction == "Delete" || dialogAction == "Blocked")) {
            let Name = props.CardData?.Contact?.Name ? props.CardData?.Contact?.Name : props.CardData?.Contact?.PhoneNumber;
            setIsLoading(true);
            var apiCall = (dialogAction === "Delete")
                ? ContactService.deleteContact(props.CardData?.Contact?.ID, false)
                : ContactService.blockUnBlockNumber(props.CardData?.PhoneNumber.replace('+', ''), !props.CardData?.IsBlocked);

            apiCall.then(() => {
                if (dialogAction === "Delete") {
                    setToast(ToasterTexts.CONTACT_DELETE_SUCCESS.replace('<Name>', Name || props.CardData?.PhoneNumber), ToasterType.SUCCESS);
                    if (IsMobileDevice && props.CardData?.Contact) {
                        dispatch(pushContacts([{ ...props.CardData.Contact, IsDeleted: true }]));
                    }
                } else {
                    setToast(!props.CardData?.IsBlocked ? ToasterTexts.CONTACT_BLOCK_SUCCESS.replace('<Name>', Name || props.CardData?.PhoneNumber) : ToasterTexts.CONTACT_UNBLOCK_SUCCESS.replace('<Name>', Name || props.CardData?.PhoneNumber), ToasterType.SUCCESS);
                }
                setShowConfirmDialog(false);
                setText("");
                setDialogAction("");
            });
        }
        else {
            setShowConfirmDialog(false)
            setText("")
            setDialogAction("")
            setIsLoading(false)
        }
    }

    const handleClose = () => {
        if (isExiting) return;
        setIsExiting(true);
    };

    const getContact = (number) => {
        let contact = Contacts.find(contact => contact.PhoneNumber === number && contact.Name)

        return UserService.getUserPhoneNumber() === number ? "You" : !!contact ? contact.Name : "--"
    }


    useEffect(() => {
        if (!!contact?.PhoneNumber && Settings.Settings?.find(x => x.Code === "AI")?.Value?.toString()?.toLowerCase() === "true") {
            if (!!ChatSummaryHistory[contact.PhoneNumber.replace("+", "")]) {
                setSentiment(ChatSummaryHistory[contact.PhoneNumber.replace("+", "")].Sentiment)
                setSummary(ChatSummaryHistory[contact.PhoneNumber.replace("+", "")].Summary)
                setbuttonName("Generate summary Again")
            }
            else {
                FalkonAiService.getLastGeneratedChatSummaryandSentimentByPhoneNumber(contact.PhoneNumber.replace("+", "")).then((res) => {
                    setSentiment(res.data.sentiment)
                    setSummary(res.data.summary)
                    setbuttonName(res.data.sentiment === "Not yet available" ? "Generate chat summary" : "Generate summary Again")
                    UpdateChatSummaryHistory(dispatch, contact.PhoneNumber.replace("+", ""), { Sentiment: res.data.sentiment, Summary: res.data.summary })
                }).catch((err) => {
                    setSentiment("No Sentiment")
                    setSummary(err.response?.data.error || "No Chat Summary")
                    setbuttonName("Generate chat summary")
                })
            }
        }
        const frame = requestAnimationFrame(() => setPanelOpen(true));
        return () => cancelAnimationFrame(frame);
    }, [])

    const handleGenerateSummary = () => {
        setLoader(true)
        const HistorytoFeed = History[contact.PhoneNumber.replace("+", "")]?.filter(x => !!x.Message).map(z => { return `${z.IsOutbound ? " Agent" : " Customer"} : ${z.Message}` })

        if (!HistorytoFeed?.length) {
            setSentiment("No Sentiment")
            setSummary("No Messages To generate summary")
            setLoader(false)
        }
        else {
            FalkonAiService.getChatSummaryandSentiment({ text: HistorytoFeed.join(""), channel: 6, contact: contact.PhoneNumber.replace("+", "") }).then(res => {
                setSentiment(res.data.sentiment)
                setSummary(res.data.summary)
                setbuttonName("Generate summary Again")
                UpdateChatSummaryHistory(dispatch, contact.PhoneNumber.replace("+", ""), { Sentiment: res.data.sentiment, Summary: res.data.summary })
                setLoader(false)
            }).catch(() => {
                handleClose()
            })
        }

    }

    const slidePanelClasses = [
        'contact-info-slide-panel',
        !panelOpen && !isExiting ? 'contact-info-slide-panel-enter' : '',
        panelOpen && !isExiting ? 'contact-info-slide-panel-open' : '',
        isExiting ? 'contact-info-slide-panel-exit' : '',
        IsMobileDevice ? 'w-p-100' : 'w-p-100 ml-1 mr-1',
        'h-p-98 br-4',
    ].join(' ');

    return (
        <div className={slidePanelClasses}>
            {
                (IsMobileDevice && openEditContact) ? <ContactViewComponent
                    onClose={closeEditContact}
                    show={openEditContact}
                    Contact={props.CardData?.Contact ||
                        {
                            PhoneNumber: props.CardData?.PhoneNumber,
                            MaskedPhoneNumber: props.CardData?.MaskedPhoneNumber,
                        } as Contact
                    }
                />
                    : <div className={`${IsDarkMode ? "bg-color-sidebar-bg h-p-100 p-1" : `${IsMobileDevice ? "bg-color-secondary h-p-100" : " bg-color-con-hist-inbound-msg-bg h-p-100 p-1"}`} ${IsMobileDevice ? "" : "br-3 pb-2"} h-p-100`} style={{ boxShadow: IsMobileDevice ? "none" : "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)" }}>
                        <div className={`d-flex px-2 py-1 my-auto ${IsMobileDevice ? `${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}  box-shadow-display-background-shadow` : " brt-2"}`}>
                            <div className={`${IsMobileDevice ? "h3 f-label-input" : "h4-semibold "} h4-semibold d-flex align-center`}>
                                {IsMobileDevice && <BackMobileIcon onClick={handleClose} className={"c-pointer mr-2 my-auto py-2"} />}
                                <span className=" h4-semibold ">{props.CardTitle}</span>
                            </div>
                            {!IsMobileDevice && <Tooltip title='   Close' placement='bottom'>
                                <CancelIcon className="c-pointer ml-auto my-auto" tabIndex={2} onClick={handleClose} />
                            </Tooltip>}
                        </div>
                        {!IsMobileDevice && <div className="d-flex bb-primary-divider-4 p-1 "></div>}
                        <div className={`d-flex justify-between align-center px-2 py-1 ${IsMobileDevice ? "mt-2" : ""}`}>
                            <div className={`d-flex align-center w-p-100 ${IsMobileDevice ? "" : " flex-direction"}`}>
                                <div className=' d-flex  align-center'>
                                    {!!props.campaignInfo ?
                                        <div className="w-5 h-5 d-flex align-center justify-cent
                            er bg-color-campaign-avator-icon-bg br-50"><GroupBrodCastCardIcon /></div> : !!props.GroupChatInfo ?
                                            <div className="w-5 h-5 d-flex align-center justify-center bg-color-groupchat-avator-icon-bg br-50"><img src={GroupchatIcon} alt="groupchat icon" /></div>
                                            : <Avatar Name={contact.Name || props.GroupChatInfo?.Name} />
                                    }
                                </div>
                                <span className={`h3-bold color-primary-accent ${IsMobileDevice ? "ml-2" : ""} my-auto w-break`}>
                                    {
                                        !!props.campaignInfo ? props.campaignInfo?.Name ? props.campaignInfo?.Name : `Campagin Name` :
                                            !!props.GroupChatInfo?.Name ? props.GroupChatInfo?.Name :
                                                props.GroupChatInfo?.PhoneNumbers ? `${props.GroupChatInfo?.PhoneNumbers.length}  people` :
                                                    contact?.Name ? contact?.Name : contact.MaskedPhoneNumber
                                    }
                                </span>
                            </div>
                            {!props.campaignInfo && !props.GroupChatInfo &&
                                <MenuItemRender HorizantelIcon={true} MenuData={contactActionData} MeetBallIcon={SettingsVertiIcon} />
                            }
                        </div>
                        {
                            props.campaignInfo?.ID && <div className='px-2'>
                                < hr />
                            </div>
                        }
                        {
                            props.campaignInfo?.ID ?
                                <>
                                    {
                                        !IsMobileDevice && <><div className='className="h6-regular color-text-primary-disabled mx-2 mt-2"s'>{UtilityService.convertToDateTimeFormat(props.campaignInfo.CreatedDateTime)}</div> <span className="h6-regular color-text-primary-disabled mx-2 mt-2">Broadcast list {props.campaignInfo.ToPhoneNumbers.length} recipients</span></>
                                    }
                                    {IsMobileDevice && <div className="px-2 d-flex justify-between mt-1">
                                        <span className="h3-regular w-p-60">Name</span>
                                        <span className="h3-regular">{ViewTextLabels.PHONE_NUMBERS}</span>
                                    </div>
                                    }
                                    <div className={`px-2 groupchat-info-border br-2 ${IsMobileDevice ? "mx-1" : "o-y-scroll h-v-30 mx-2 groupchat-info-background"}`}>
                                        {
                                            props.campaignInfo?.ToPhoneNumbers.map(number => (
                                                <div className="py-1 d-flex justify-between align-center">
                                                    <span className={`${IsMobileDevice ? "h4-regular" : "h6-regular"} w-p-60 w-break`}>{getContact(number)}</span>
                                                    <span className={`${IsMobileDevice ? "h4-regular" : "h6-regular"}`}>{UtilityService.maskPhoneNumberOnLength(number)}</span>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </>
                                : props.GroupChatInfo?.ID ?
                                    <>
                                        {
                                            !IsMobileDevice && <span className="h6-regular color-text-field-label mx-2 mt-2">Participants and Phone Numbers</span>
                                        }
                                        {IsMobileDevice && <div className="px-2 d-flex justify-between mt-1">
                                            <span className="h3-regular w-p-60">Name</span>
                                            <span className="h3-regular">{ViewTextLabels.PHONE_NUMBERS}</span>
                                        </div>
                                        }
                                        <div className={`px-2 groupchat-info-border br-2 ${IsMobileDevice ? "mx-1" : IsDarkMode ? "bg-color-sidebar-bg o-y-scroll h-v-30 mx-2" : "o-y-scroll h-v-30 mx-2 groupchat-info-background "}`}>
                                            {
                                                props.GroupChatInfo?.PhoneNumbers.map(number => (
                                                    <div className="py-1 d-flex justify-between align-center">
                                                        <span className={`${IsMobileDevice ? "h4-regular" : "h6-regular"} w-p-60 w-break`}>{getContact(number)}</span>
                                                        <span className={`${IsMobileDevice ? "h4-regular" : "h6-regular"}`}>{UtilityService.maskPhoneNumberOnLength(number)}</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </>
                                    :
                                    <div className='px-2'>
                                        <div className={`${IsMobileDevice ? "h3-regular" : "h5-semibold mt-1"}`}>
                                            {ViewTextLabels.PHONE_NUMBER}
                                        </div>
                                        <div className={`${IsMobileDevice ? "h4-regular py-2" : "h6-regular"} p-1 color-primary`}>
                                            {contact.MaskedPhoneNumber || UtilityService.maskPhoneNumberOnLength(contact?.PhoneNumber)}                            </div>
                                        <div className={`${IsMobileDevice ? "h3-regular" : "h5-semibold mt-1"} w-break`}>
                                            {ViewTextLabels.EMAIL_ID}
                                        </div>
                                        <div className={`${IsMobileDevice ? "h4-regular py-2" : "h6-regular"} p-1 color-primary contactinfo-email`}>
                                            {(contact?.Email) ? contact?.Email : "--"}
                                        </div>

                                        <div className={`${IsMobileDevice ? "h3-regular" : "h5-semibold mt-1"}`}>
                                            {ViewTextLabels.GROUPS}
                                        </div>
                                        {contact?.Groups?.length ?
                                            <div className='mt-2 max-h-10 o-y-auto p-1 h-fill'>
                                                {contact?.Groups?.map((data: Group) =>
                                                    <Chip size="small" className="mb-1 mr-1 h6-regular bg-color-contact-info-group-chip color-secondary"
                                                        key={data.ID}
                                                        label={data.Name} />
                                                )
                                                }
                                            </div>
                                            :
                                            <div className={`${IsMobileDevice ? "h4-regular" : "h6-regular"} p-1 color-primary`}>
                                                {"--"}
                                            </div>
                                        }
                                        {Settings.Settings?.find(x => x.Code === "AI")?.Value?.toString()?.toLowerCase() === "true" &&
                                            <>
                                                <div className={`${IsMobileDevice ? "h3-regular" : "h5-semibold mt-1"}`}>
                                                    Customer Sentiment
                                                </div>
                                                <div className={`${IsMobileDevice ? "h4-regular" : "h6-regular"} p-1 satisfaction-${sentiment} color-primary`}>
                                                    {sentiment} {sentiment === "Frustrated" ? "😡" : sentiment === "Unhappy" ? "😞" : sentiment === "Neutral" ? "😐" : sentiment === "Happy" ? "🙂" : sentiment === "Delighted" && "😍"}
                                                </div>
                                                <div className={`${IsMobileDevice ? "h3-regular" : "h5-semibold mt-1"}`}>
                                                    Chat Summary
                                                </div>
                                                <div className={` px-1 color-primary contactinfo-email ${IsMobileDevice ? "h4-regular my-2 max-h-14" : "h6-regular max-h-20"} o-y-scroll`}>
                                                    {summary}
                                                </div>
                                                <div className='d-flex justify-center'>
                                                    <ButtonComponent Loading={loader} ClassName='w-p-80' ButtonLabel={ButtonName} Variant={'ai-primary-btn'} Icon={FalkonAiWhiteIcon} OnClick={handleGenerateSummary} />
                                                </div>
                                            </>
                                        }
                                    </div>
                        }
                    </div>}

            {
                openEditContact && !IsMobileDevice &&
                <ContactViewComponent
                    onClose={closeEditContact}
                    show={openEditContact}
                    Contact={contact ||
                        {
                            PhoneNumber: props.CardData?.PhoneNumber,
                            MaskedPhoneNumber: props.CardData?.MaskedPhoneNumber,
                        } as Contact
                    }
                />
            }
            {
                showConfirmDialog &&
                <Confirm_Dialog
                    Show={showConfirmDialog}
                    onClose={(e: any) => { closeConfirmDialog(e) }}
                    Text={text}
                    ButtonName={dailogButtonName}
                    Loading={isloading} />
            }
        </div>
    )
}

export default ContactInfoComponentNew;